module.exports = __webpack_public_path__ + "static/media/vplus_logo.d645e700.png";